import { post } from 'stores/_services/dataService';

export { getUrl, buildDownloadUrl, buildCsvDownloadUrl, downloadFromPayload, downloadFromUrl };

async function getDownloadToken(route) {
    let res = await post('users/me/downloadToken', { route });
    return res.data.id;
}

async function getUrl(route) {
    let url = `/api/${route}`;
    let token = await getDownloadToken(url);
    return `${url}${getParamDelimiter(url)}access_token=${token}`;
}

async function buildCsvDownloadUrl(route, query = '') {
    let url = `/api/${route}/csv${query}`;
    let token = await getDownloadToken(`/api/${route}`);
    return `${url}${getParamDelimiter(url)}access_token=${token}`;
}

async function buildDownloadUrl(route, query = '') {
    let url = `/api/${route}${query}`;
    let token = await getDownloadToken(`/api/${route}`);
    return `${url}${getParamDelimiter(url)}access_token=${token}`;
}

function getParamDelimiter(url) {
    return url && url.indexOf('?') > -1 ? '&' : '?';
}

function downloadFromPayload(name, payload, fileType, fileExtension) {
    fileType = fileType || 'blob';
    fileExtension = fileExtension || 'bin';

    let data;
    let filename = `${name}.${fileExtension}`;

    if (fileType === 'blob') {
        let byteArray = new Uint8Array(payload);
        data = new Blob([byteArray], { type: 'application/octet-stream' });
    } else if (fileType === 'file') {
        data = new File(payload, filename);
    }

    // IE 11 anyone?
    if (window.navigator.msSaveBlob) return window.navigator.msSaveBlob(data, filename);

    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(data);
    downloadLink.download = filename;
    downloadLink.style.display = 'none';

    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.parentNode.removeChild(downloadLink);
}

function downloadFromUrl(url, filename, target) {
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = filename;
    downloadLink.style.display = 'none';

    if (target) {
        downloadLink.target = target;
    }

    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.parentNode.removeChild(downloadLink);
}
